/* EBB mobile helpers — image counter for the PDP swipe gallery.
   Mobile-only; no-ops on desktop and on pages without a gallery. */
(function () {
  function init() {
    if (!window.matchMedia('(max-width: 768px)').matches) return;
    var gal = document.getElementById('pdp-gal');
    if (!gal) return;
    var slides = gal.querySelectorAll('.pdp-img');
    if (slides.length < 2) return;

    var pill = document.createElement('div');
    pill.className = 'ebb-gal-count';
    pill.setAttribute('aria-hidden', 'true');
    pill.textContent = '1 / ' + slides.length;
    gal.parentNode.insertBefore(pill, gal.nextSibling);

    var ticking = false;
    gal.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(gal.scrollLeft / gal.clientWidth) + 1;
        i = Math.max(1, Math.min(slides.length, i));
        pill.textContent = i + ' / ' + slides.length;
        ticking = false;
      });
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ── Category hover photos — real lifestyle shots for the homepage category strip.
   Enhances window.catHover (defined in theme.js) so a category with a photo paints
   it full-cover across #catImg instead of drawing the generated SVG figure.
   Each entry: { url, pos } where pos is a CSS background-position controlling the
   crop focal point (the panel is wide/short, so portrait shots need a tuned pos).
   Extensible: add more entries to CAT_PHOTOS keyed by the exact category label. ── */
(function () {
  var CAT_PHOTOS = {
    'Shirts': { url: 'https://cdn.shopify.com/s/files/1/0739/8604/8078/files/ebb-shirts-lifestyle-v3.jpg?v=1786311829', pos: 'center 55%' },
    'Shorts': { url: 'https://cdn.shopify.com/s/files/1/0739/8604/8078/files/ebb-shorts-lifestyle.jpg?v=1786309535', pos: 'center center' },
    'Polos': { url: 'https://cdn.shopify.com/s/files/1/0739/8604/8078/files/ebb-polos-lifestyle-v2.jpg?v=1790401877', pos: 'center center' }
  };
  var CAT_URLS = {
    'Shirts': '/collections/all?cat=Shirts',
    'Shorts': '/collections/shorts',
    'Polos': '/collections/polos',
    'Quarter Zips': '/collections/quarter-zips',
    'Hoodies': '/collections/hoodies'
  };

  function wrap() {
    if (typeof window.catHover !== 'function') return false;
    if (window.catHover.__ebbPhotoWrapped) return true;
    var orig = window.catHover;
    var wrapped = function (cat, el) {
      var entry = CAT_PHOTOS[cat];
      if (!entry) { return orig(cat, el); }
      var photo = entry.url;
      var pos = entry.pos || 'center center';
      var items = document.querySelectorAll('.cat-item');
      for (var i = 0; i < items.length; i++) items[i].classList.remove('hi');
      if (el) el.classList.add('hi');
      var box = document.getElementById('catImg');
      if (!box) return;
      box.onclick = function () { window.location = CAT_URLS[cat] || '/collections/all'; };
      box.style.transition = 'opacity .15s';
      box.style.opacity = '0';
      setTimeout(function () {
        box.innerHTML = '';
        box.style.backgroundImage = 'url(' + photo + ')';
        box.style.backgroundSize = 'cover';
        box.style.backgroundPosition = pos;
        box.style.backgroundRepeat = 'no-repeat';
        box.style.opacity = '1';
      }, 150);
    };
    wrapped.__ebbPhotoWrapped = true;
    window.catHover = wrapped;
    return true;
  }

  if (!wrap()) {
    document.addEventListener('DOMContentLoaded', wrap);
    var n = 0;
    var iv = setInterval(function () { if (wrap() || ++n > 30) clearInterval(iv); }, 100);
  }
})();

/* ── FLOW footer relabel — the footer 'Company' link to /pages/athlete-program IS the
   FLOW athlete program. Keep the href, show the brand name. Done in JS so the 20KB
   footer (which holds the Klaviyo signup script) isn't touched. ── */
(function () {
  function relabel() {
    var links = document.querySelectorAll('a[href="/pages/athlete-program"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].textContent.trim() !== 'Flow') links[i].textContent = 'Flow';
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', relabel);
  else relabel();
})();



/* ── Category strip: touch equivalent of the hover-preview (dead on iPhone —
   mouseenter never fires on touch). First tap on an untapped item previews
   the photo via catHover() and blocks navigation; tapping the same
   (already-tapped) item again lets the link through normally. No-ops on
   real hover devices so desktop behavior (instant nav) is unchanged. ── */
window.ebbCatTap = function (e, name, el) {
  if (!window.matchMedia('(hover: none)').matches) return;
  if (!el.classList.contains('cat-tapped')) {
    e.preventDefault();
    document.querySelectorAll('.cat-item.cat-tapped').forEach(function (i) { i.classList.remove('cat-tapped'); });
    el.classList.add('cat-tapped');
    if (typeof window.catHover === 'function') window.catHover(name, el);
  }
};

/* ── Product card quick-add (touch): close any open size panel when tapping
   outside a card. Mirrors the equivalent handler for the main collection
   grid's .ecc-szs quick-add panels. ── */
document.addEventListener('click', function (e) {
  if (e.target.closest('.product-card')) return;
  document.querySelectorAll('.product-card__sizes.open').forEach(function (el) { el.classList.remove('open'); });
});
